var map = {
	"./classManagementIcon.png": 32306,
	"./correctIcon.png": 23721,
	"./courseInformationIcon.png": 26446,
	"./courseTeachingIcon.png": 52706,
	"./defineIcon.png": 17635,
	"./deleteIcon.png": 45445,
	"./detailIcon.png": 4098,
	"./documentResourcesIcon.png": 64945,
	"./errorIcon.png": 36430,
	"./goBackToMySpaceIcon.png": 14913,
	"./homepage/searchIcon.png": 80226,
	"./homepage/sharedIcon.png": 23586,
	"./register/passwordIcon.png": 35729,
	"./register/userIcon.png": 48681,
	"./resourceManagement/blueIcon.png": 27186,
	"./resourceManagement/greyIcon.png": 28523,
	"./resourceManagement/searchIcon.png": 72313,
	"./resourceManagementIcon.png": 11469,
	"./studentStatisticsIcon.png": 75326,
	"./viewPointsIcon.png": 27853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74700;